import { FC, PropsWithChildren, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useGetOffersByDeviceType } from '../../hooks';

/**
 * Компонент-прослойка для запроса объявлений при их появлении в области видимости
 */
export const OffersIntersectionObserver: FC<PropsWithChildren> = ({ children }) => {
  const getOffers = useGetOffersByDeviceType();

  const { ref, inView } = useInView({
    rootMargin: '300px',
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      getOffers();
    }
  }, [getOffers, inView]);

  return <div ref={ref}>{children}</div>;
};
